<template>
  <div class="g-backtop">
    <BackTop :height="800" :right="50" :bottom="175">
      <div class="top">
        <img src="./img/top.png">
      </div>
    </BackTop>
  </div>
</template>

<script>
export default {
  name: "g-backtop",
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.g-backtop {
  .top {
    width: 54px;
    height: 54px;
    background-color: #00bdca;
    &:hover {
      background-color: #db2a4b;
    }
  }
  img {
    width: 54px;
    height: 54px;
  }
  /deep/ .ivu-back-top {
    left: 50%;
    margin-left: 610px;
  }
}
</style>